import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';


import { ProjectService } from '../../../../services/project.service';
import { UiService } from '../../../../services/core.ui.service';
import { GfTranslateService } from '../../../../services/core.translate.service';
import { StateService } from '@uirouter/angular';
import { ModalComponent } from '../../../../config/core.modal-helpers';

@Component({
    selector: 'adminEditProjectModal',
    template: require('./admin.project-edit.component.html')
})
export class AdminEditProjectComponent extends ModalComponent implements OnInit {

    @Input() project: any = null;

    constructor(
        private projectService: ProjectService,
        private gfTranslateService: GfTranslateService,
        public stateService: StateService, 
        
        private uiService: UiService        
    ) { super(); }

    ngOnInit() { }


    saveProject = () => {

        if (!this.project) this.closeModal();
        var success = false;

        this.projectService.save(this.project.unixName, this.project)
            .then(() => {
                this.uiService.message.showSuccess(
                    this.gfTranslateService.translate('Saved project {{name}}', this.project)
                );
                success = true;
            }, (response) => {
                console.log(response);
                this.uiService.message.showError(
                    this.gfTranslateService.translate('Failed to save project {{name}}', this.project)
                );
            }).finally(() =>
                this.closeModal(success)
            )
    };
}